export default {
  'ActionTableHeader.Checkbox.Checkbox': ({ }, outlet) => {
    outlet({ action: 'select' })
  },
  'ActionTableHeader.Buttons.Button': ({ action }, outlet) => {
    outlet({ action })
  },
  'ActionTableHeader.Checkbox.Button': ({ }, outlet) => {
    outlet({ action: 'deselect' })
  },
}